// src/routes/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = () => {
  const { authUser, loading } = useAuth();

  // Đang đọc trạng thái đăng nhập + lấy profile => đừng điều hướng vội
  if (loading) return null; // hoặc trả về spinner

  // Đã đăng nhập thì cho vào, chưa đăng nhập thì về /login
  return authUser ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
